// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M10.59 2.81A2 2 0 0 1 13.42 2.81L21.2 10.59A2 2 0 0 1 21.2 13.42L13.42 21.2A2 2 0 0 1 10.59 21.2L2.81 13.42A2 2 0 0 1 2.81 10.59ZM12 15A1 1 0 1 0 12 17L12 17A1 1 0 0 0 12 15ZM12 8A1.44 1.44 0 0 0 10.57 9.62L11.01 13.12A1 1 0 0 0 12.99 13.12L13.43 9.62A1.44 1.44 0 0 0 12 8"/>';

/** Alert (status). */
const icon: IconData = {
  id: "alert",
  name: "Alert",
  category: "status",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: m0 },
    outline: {
      svg: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 16L12 16M12 13L11.56 9.5A.44.44 0 1 1 12.44 9.5ZM3.52 12.71L11.3 20.49A1 1 0 0 0 12.71 20.49L20.49 12.71A1 1 0 0 0 20.49 11.3L12.71 3.52A1 1 0 0 0 11.3 3.52L3.52 11.3A1 1 0 0 0 3.52 12.71"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M12.2 2.25L12.93 2.47 13.42 2.81 21.32 10.75 21.69 11.44 21.76 12.2 21.54 12.93 21.2 13.42 13.26 21.32 12.57 21.69 11.81 21.76 11.08 21.54 10.59 21.2 2.69 13.26 2.32 12.57 2.25 11.81 2.47 11.08 2.81 10.59 10.75 2.69 11.44 2.32Z"/></g><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 16L12 16M12 13L11.56 9.5A.44.44 0 1 1 12.44 9.5ZM3.52 12.71L11.3 20.49A1 1 0 0 0 12.71 20.49L20.49 12.71A1 1 0 0 0 20.49 11.3L12.71 3.52A1 1 0 0 0 11.3 3.52L3.52 11.3A1 1 0 0 0 3.52 12.71"/>',
    },
  },
  animation: () => import("../animations/alert.js"),
};

export default icon;
